<template>
<v-layout align-center justify-center>
  <v-flex>
    <v-card flat>
      <v-card-title scrollable class="px-1">
        <v-list ref="chat">
          <div class="messages" ref="messages">
            <transition-group enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
              <message v-for="message in groupMessages" :key="message.date.toString()" :sender="message.sender === $store.getters.uid ? true: false" :details="message"></message>
            </transition-group>
          </div>
        </v-list>
      </v-card-title>
      <v-card-text scrollable class="px-1 pr-3">
        <v-form @submit.prevent="sendMessage">
          <v-textarea box append-outer-icon="send" @click:append-outer="sendMessage" color="green" placeholder="Message" v-model="userMessage" counter maxlength="120" full-width>
          </v-textarea>
        </v-form>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import Message from "@/components/Chat/Message";
import firebase, {
  db
} from "@/firebaseConfig";
import {
  log
} from "util";

export default {
  name: "Chat",
  components: {
    Message
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      userMessage: "",
      groupMessages: []
    };
  },
  methods: {
    scrollToBottom() {
      this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
    },
    sendMessage() {
      if (this.userMessage !== "") {
        db.collection("projects")
          .doc(this.$route.params.groupID)
          .collection("messages")
          .add({
            date: new Date(),
            displayName: this.user.displayName,
            message: this.userMessage,
            photoURL: this.user.photoURL,
            sender: this.$store.getters.uid
          })
          .then(() => {
            this.scrollToBottom();
          });
        this.userMessage = "";
      }
    },
    loadGroupMessages() {
      this.$bind(
        "groupMessages",
        db
        .collection("projects")
        .doc(this.$route.params.groupID)
        .collection("messages")
        .orderBy("date", "asc")
      ).then(groupMessages => {
        this.groupMessages === groupMessages;
        this.scrollToBottom();
      });
    }
  },
  created() {
    this.loadGroupMessages();
  },
  watch: {
    // Reload the group's messages when the user switches groups
    "$route.params.groupID" (id) {
      this.loadGroupMessages();
    }
  }
};
</script>

<style lang="scss" scoped>
// Chat sidebar header
#header {
    display: block;
    transition: 1s;
    // flex: 0;
}
.v-list {
    width: 100%;
}
.sidebar {
    color: white;
    height: 100%;
    width: 0;
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    background-color: #3c3c3c;
    overflow-x: hidden;
    transition: 1s;
    padding-top: 10px;

    // Content is the flex container that holds everything
    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
    }
}

// Messages container
.messages {
    flex: 1;
    overflow-y: auto;
    height: 64vh;
    @media only screen and (max-width: 1240px) {
        height: 75vh;
    }
}
form {
    width: 100%;
}
.message-input {
    width: 80%;
    resize: none;
}

.collapsed {
    width: 0;
    transition: 1s;
}

.text {
    display: block;
    transition: 1s;
}

.active {
    width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Chat/Chat.vue